import { ReactNode } from "react";
import { Role } from "@/types/role.enum";
import { useIsRole } from "@/hooks/useIsRole";

type RoleValue = (typeof Role)[keyof typeof Role];

interface RoleOnlyProps {
  children: ReactNode;
  fallback?: ReactNode | (() => ReactNode);
  allowedRoles?: RoleValue[];
  extraCondition?: boolean;
}

const RoleOnly = ({
  children,
  fallback = null,
  allowedRoles = [Role.HOST],
  extraCondition = true,
}: RoleOnlyProps) => {
  const hasRole = useIsRole(allowedRoles);

  if (hasRole && extraCondition) return children;

  return typeof fallback === "function" ? fallback() : fallback;
};

export default RoleOnly;
